import { EventEmitter } from '@angular/core';
import { XML_FILE_TYPE } from 'Angular/constants/data-upload.constants';
import { UrlsService } from 'Angular/services/core/urls.service';
import { MultilineFileUploadComponent } from 'Angular/features/components/file-upload/multiline-file-upload/multiline-file-upload.component';
import { ConfirmModalComponent } from 'Angular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/urls.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i4 from "../../../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i5 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i8 from "../../../../../../../../../../../ycharts/static/ts/features/components/file-upload/multiline-file-upload/multiline-file-upload.component";
const _c0 = ["fileUploadModal"];
const _c1 = ["alertStaleAccountsData"];
function AdvyzonUploadAccountsModalComponent_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol");
} }
function AdvyzonUploadAccountsModalComponent_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r2.errorMessage);
} }
function AdvyzonUploadAccountsModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "div", 11);
    i0.ɵɵtemplate(3, AdvyzonUploadAccountsModalComponent_div_4_div_3_Template, 1, 1, "div", 12);
    i0.ɵɵelementStart(4, "div", 13)(5, "b");
    i0.ɵɵtext(6, "To connect your Advyzon account positions to YCharts, please complete the following steps:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 13);
    i0.ɵɵtext(8, " 1. In Advyzon, locate the section \u201CAll Reports\u201D. Choose Firm Reports > Account Position. Click \u201CGenerate Data Now\u201D prior to downloading the report. If you have any questions, please reach out to your YCharts support contact. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 13);
    i0.ɵɵtext(10, " 2. Upload the XML file output below. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 13);
    i0.ɵɵtext(12, " Once the data has been added to your account, you will begin importing data directly within the portfolios page. For more information on steps to access the file in Advyzon, view additional resources in our support section here. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 13)(14, "b");
    i0.ɵɵtext(15, "Note");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(16, ": The process to get the data added to your account so that you can import into YCharts occurs instantaneously. This data will be as of the date that you chose prior to exporting the XML file from Advyzon. The \u201Cas-of\u201D date for your data can be located in the import menu and on this upload page. To refresh your data, upload a new file from Advyzon. To schedule recurring XML file downloads, prepare a task in Advyzon Report Center. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 13)(18, "ycn-multiline-file-upload", 14, 1);
    i0.ɵɵlistener("errorHandler", function AdvyzonUploadAccountsModalComponent_div_4_Template_ycn_multiline_file_upload_errorHandler_18_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.uploadErrorHandler($event)); });
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.errorMessage !== "");
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("uploadUrl", ctx_r2.accountsFileUploadUrl)("uploadFieldName", ctx_r2.uploadFieldName)("validFileTypesType", ctx_r2.validFileTypesType)("maxFileSizeInBytes", 20000 * 1024)("successfulUploadConfirmMessage", " Your file is in the correct format and has been successfully processed.");
} }
export class AdvyzonUploadAccountsModalComponent {
    constructor(urlsService) {
        this.urlsService = urlsService;
        this.closeModalHandler = new EventEmitter();
        this.confirmHandler = new EventEmitter();
        this.errorMessage = '';
        this.loading = false;
        this.uploadFieldName = 'form';
        this.validFileTypesType = [XML_FILE_TYPE];
        this.accountsFileUploadUrl = '';
        this.staleAccountsDataWarning = 'Provided accounts data is older than existing accounts. Upload a file with updated accounts data to import the most recent positions. ';
        this.modalOpen = false;
        this.accountsFileUploadUrl = this.urlsService.ACCOUNTS.INTEGRATIONS_ADVYZON_ACCOUNTS_UPLOAD;
    }
    ngOnInit() { }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.errorMessage = '';
        this.closeModalHandler.emit();
    }
    onSubmit() {
        this.closeModal();
    }
    uploadErrorHandler(response) {
        if (response.error_code === 'outdated_accounts_data') {
            this.alertModal.openModal();
        }
    }
    forceUploadAccounts(confirmed) {
        if (confirmed) {
            this.uploadModal.retryWithUrl(`${this.accountsFileUploadUrl}?overwrite=true`);
        }
    }
}
AdvyzonUploadAccountsModalComponent.ɵfac = function AdvyzonUploadAccountsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AdvyzonUploadAccountsModalComponent)(i0.ɵɵdirectiveInject(i1.UrlsService)); };
AdvyzonUploadAccountsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AdvyzonUploadAccountsModalComponent, selectors: [["ycn-advyzon-integration-upload-accounts-modal"]], viewQuery: function AdvyzonUploadAccountsModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.uploadModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alertModal = _t.first);
    } }, outputs: { closeModalHandler: "closeModalHandler", confirmHandler: "confirmHandler" }, standalone: false, decls: 8, vars: 12, consts: [["alertStaleAccountsData", ""], ["fileUploadModal", ""], [3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "submitButtonText", "cancelButtonText", "showSubmitButton"], [3, "confirmHandler", "confirmButtonText", "cancelButtonText", "confirmHeader", "confirmText"], [1, "modal-section"], [1, "row"], [1, "col"], ["class", "form-row text-red", 3, "textContent", 4, "ngIf"], [1, "form-row"], [3, "errorHandler", "uploadUrl", "uploadFieldName", "validFileTypesType", "maxFileSizeInBytes", "successfulUploadConfirmMessage"], [1, "form-row", "text-red", 3, "textContent"]], template: function AdvyzonUploadAccountsModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function AdvyzonUploadAccountsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function AdvyzonUploadAccountsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 4);
        i0.ɵɵtemplate(3, AdvyzonUploadAccountsModalComponent_ycn_loading_symbol_3_Template, 1, 0, "ycn-loading-symbol", 5)(4, AdvyzonUploadAccountsModalComponent_div_4_Template, 20, 6, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-simple-modal-footer", 7);
        i0.ɵɵlistener("cancelHandler", function AdvyzonUploadAccountsModalComponent_Template_ycn_simple_modal_footer_cancelHandler_5_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); })("submitHandler", function AdvyzonUploadAccountsModalComponent_Template_ycn_simple_modal_footer_submitHandler_5_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onSubmit()); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "ycn-confirm-modal", 8, 0);
        i0.ɵɵlistener("confirmHandler", function AdvyzonUploadAccountsModalComponent_Template_ycn_confirm_modal_confirmHandler_6_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.forceUploadAccounts($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-dialog")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Upload Advyzon Accounts");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("submitButtonText", "Activate")("cancelButtonText", "Close")("showSubmitButton", false);
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmButtonText", "Save Anyway")("cancelButtonText", "Return to Data Upload")("confirmHeader", "Alert")("confirmText", ctx.staleAccountsDataWarning);
    } }, dependencies: [i2.NgIf, i3.ConfirmModalComponent, i4.LoadingSymbolComponent, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.SimpleModalHeaderComponent, i8.MultilineFileUploadComponent], encapsulation: 2 });
